module.exports = __webpack_public_path__ + "35bb0ad95a0e2e58fffbc3d5aea9a069.png";